import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  const credits = window.__ENV && window.__ENV.credits;

  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col sm={6}>{new Date().getFullYear()} © {credits}.</Col>
            <Col sm={6}>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>

  );
}

export default Footer;